<a [href]="getUrl()">
  <div class="meeting-card flex row" [class.last]="isLast()">
    <div class="flex-column">
      <div class="date">{{ HELPER.formatDateWithLocalizedMonth(meetingData().startDate) }}
        - {{ HELPER.formatDateWithLocalizedMonth(meetingData().endDate) }}
      </div>
      <div class="text-md text--semi-bold title">{{ meetingData().title }}</div>
      @if (hasDesc()) {
        <div class="text-sm description"
             [innerHTML]="meetingData().summary || meetingData().htmlDescription | removeHtml"></div>
      }
    </div>
  </div>
</a>
